<template>
  <div class="sh-city" ref="target">
    <div class="select" @click="changeDialog" :class="{ active }">
      <span v-if="!fullLocation" class="placeholder">请选择配送地址</span>
      <span v-else class="value">{{ fullLocation }}</span>
      <el-icon><ArrowDown /></el-icon>
    </div>
    <div class="option" v-if="active">
      <div v-if="loading" class="loading"></div>
      <template v-else>
        <span
          @click="changeItem(item)"
          class="ellipsis"
          v-for="item in currList"
          :key="item.code"
          >{{ item.name }}</span
        >
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ref, reactive, computed } from "vue";
import { onClickOutside } from "@vueuse/core";
export default {
  name: "ShCity",
  props: {
    fullLocation: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const cityData = ref([]);
    // 控制展开收起,默认收起
    const active = ref(false);
    const open = () => {
      active.value = true;
      loading.value = true;
      //获取城市数据
      getCityData().then((data) => {
        //console.log(data);
        cityData.value = data;
        loading.value = false;
      });
      // 清空选择结果
      for (const key in changeResult) {
        changeResult[key] = "";
      }
    };
    const close = () => {
      active.value = false;
      loading.value = false;
    };
    // 切换展开收起
    const changeDialog = () => {
      if (active.value) close();
      else open();
    };
    // 点击其他位置隐藏
    const target = ref(null);
    onClickOutside(target, () => {
      close();
    });

    // 定义计算属性
    const currList = computed(() => {
      //省份
      let currList = cityData.value;
      //市
      if (changeResult.provinceCode) {
        currList = currList.find(
          (p) => p.code === changeResult.provinceCode
        ).areaList;
        //console.log(currList);
      }
      //县区
      if (changeResult.cityCode) {
        currList = currList.find(
          (c) => c.code === changeResult.cityCode
        ).areaList;
        //console.log(currList);
      }

      // TODO 根据点击的省份城市获取对应的列表
      return currList;
    });
    //console.log(currList);

    //点击切换城市
    const changeResult = reactive({
      provinceCode: "",
      provinceName: "",
      cityCode: "",
      cityName: "",
      countyCode: "",
      countyName: "",
      fullLocation: "",
    });

    const changeItem = (item) => {
      // 省份
      if (item.level === 0) {
        changeResult.provinceCode = item.code;
        changeResult.provinceName = item.name;
      }
      // 市
      if (item.level === 1) {
        changeResult.cityCode = item.code;
        changeResult.cityName = item.name;
      }
      //县区
      if (item.level === 2) {
        changeResult.countyCode = item.code;
        changeResult.countyName = item.name;
        changeResult.fullLocation = `${changeResult.provinceName} ${changeResult.cityName} ${changeResult.countyName}`;
        close();
        emit("change", changeResult);
      }
    };
    return { active, changeDialog, target, currList, changeItem, loading };
  },
};

//获取城市组件函数
const getCityData = () => {
  // 这个位置可能有异常操作，封装成promise
  return new Promise((resolve, reject) => {
    if (window.cityData) {
      // 有缓存
      resolve(window.cityData);
    } else {
      // 无缓存
      const url =
        "https://yjy-oss-files.oss-cn-zhangjiakou.aliyuncs.com/tuxian/area.json";
      axios.get(url).then((res) => {
        //console.log(res.data);
        window.cityData = res.data;
        resolve(window.cityData);
      });
    }
  });
};
</script>

<style scoped lang="less">
.sh-city {
  display: inline-block;
  position: relative;
  z-index: 400;
  .select {
    border: 1px solid #e4e4e4;
    height: 30px;
    padding: 0 5px;
    line-height: 28px;
    cursor: pointer;
    &.active {
      background: #fff;
    }
    .placeholder {
      color: #999;
    }
    .value {
      color: #666;
      font-size: 12px;
    }
    i {
      font-size: 12px;
      margin-left: 5px;
    }
  }
  .option {
    width: 542px;
    border: 1px solid #e4e4e4;
    position: absolute;
    left: 0;
    top: 29px;
    background: #fff;
    min-height: 30px;
    line-height: 30px;
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    .loading {
      height: 290px;
      width: 100%;
      background: url(../../../public/icon/playing.gif) no-repeat center;
    }
    > span {
      width: 130px;
      text-align: center;
      cursor: pointer;
      border-radius: 4px;
      padding: 0 3px;
      &:hover {
        background: #f5f5f5;
      }
    }
  }
}
</style>
